import { render, staticRenderFns } from "./DragAndDropFiles.vue?vue&type=template&id=9c6f6c00&"
import script from "./DragAndDropFiles.vue?vue&type=script&lang=js&"
export * from "./DragAndDropFiles.vue?vue&type=script&lang=js&"
import style0 from "./DragAndDropFiles.vue?vue&type=style&index=0&id=9c6f6c00&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports